import { CloseCircleOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Form } from 'antd'

type FormFooterProps = {
  onSave: () => void
  onCancel: () => void
  showCancel: boolean
  errorMessage?: string
}

export function FormFooter({ onSave, onCancel, showCancel, errorMessage }: FormFooterProps) {
  return (
    <Horizontal verticalCenter className='p-3' style={{ borderTop: '1px solid var(--gray-200)' }}>
      <Form.Item noStyle>
        <GraviButton success buttonText='Save' htmlType='submit' onClick={onSave} />
      </Form.Item>
      {showCancel && (
        <GraviButton
          className='ml-4'
          error
          icon={<CloseCircleOutlined />}
          buttonText='Cancel Outage'
          onClick={onCancel}
          data-cy='cancel-edit-outage-btn'
        />
      )}
      <Texto appearance='error' className='flex-1 mr-4'>
        {errorMessage}
      </Texto>
    </Horizontal>
  )
}
